import PropTypes from 'prop-types';
import { BsCheckCircle, BsPauseCircle } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import Panel from '#globalComponents/Overlay/Panel';
import { formatDate } from '#lib/dateUtils';

const DONE_VIEW = {
	cancelled: {
		title: 'Ihre Kündigung ist eingegangen',
		Icon: BsCheckCircle,
		iconClasses: 'bg-success-200 text-success-700',
	},
	paused: {
		title: 'Ihre Pause ist eingerichtet',
		Icon: BsPauseCircle,
		iconClasses: 'bg-primary-100 text-primary-600',
	},
};

function buildBody({ kind, subscription, wasCancelling }) {
	if (kind === 'paused') {
		const startsAt = formatDate(subscription.pause?.startsAt);
		const resumesAt = formatDate(subscription.pause?.resumesAt);
		const revertSentence = wasCancelling ? ' Ihre Kündigung ist damit zurückgenommen.' : '';
		return `Ab dem ${startsAt} pausiert Ihr Abonnement bis zum ${resumesAt}. Bis dahin nutzen Sie B2B Hero wie gewohnt; während der Pause bleiben Ihre Daten sichtbar. Am ${resumesAt} läuft Ihr Abo automatisch weiter.${revertSentence}`;
	}

	const endText = subscription.currentPeriodEnd
		? `am ${formatDate(subscription.currentPeriodEnd)}`
		: 'zum Ende der aktuellen Abrechnungsperiode';
	return `Ihr Zugang endet ${endText}. Falls Sie es sich anders überlegen, können Sie die Kündigung bis dahin in den Abo-Einstellungen zurücknehmen.`;
}

export default function DoneStep({ kind, subscription, wasCancelling = false, onClose }) {
	const { title, Icon, iconClasses } = DONE_VIEW[kind];

	return (
		<>
			<Panel.Header onClose={onClose}>{title}</Panel.Header>

			<Panel.Body>
				<div className="flex flex-col items-center text-center space-y-4 py-2">
					<div className={`flex h-9 w-9 items-center justify-center rounded-control ${iconClasses}`}>
						<Icon className="h-4 w-4" />
					</div>
					<p className="max-w-md text-sm text-bgBase-800">
						{buildBody({ kind, subscription, wasCancelling })}
					</p>
				</div>
			</Panel.Body>

			<Panel.Footer className="justify-end">
				<Button variant="solid" onClick={onClose}>
					Schließen
				</Button>
			</Panel.Footer>
		</>
	);
}

DoneStep.propTypes = {
	kind: PropTypes.oneOf(['cancelled', 'paused']).isRequired,
	subscription: PropTypes.shape({
		currentPeriodEnd: PropTypes.string,
		pause: PropTypes.shape({ startsAt: PropTypes.string, resumesAt: PropTypes.string }),
	}).isRequired,
	wasCancelling: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
};
